var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-history"},[_c('div',{staticClass:"main-wrapper"},[(!_vm.isMobile)?_c('div',{staticClass:"sidebar"},[_c('Filters',{attrs:{"tab":"orderHistory"}})],1):_vm._e(),_c('OrderList',{attrs:{"tab":"orderHistory"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }